function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
import * as React from 'react';
import PropTypes from 'prop-types';
import { compose, getContext, setDisplayName } from 'recompose';
import TextTruncate from "../TextTruncate";
import { H4, Label, View } from "../Typography";
import { color } from "../../../styles/theme";
export var CARD_TEXT_TYPE = {
  LABEL: 'label',
  SUBTITLE: 'subtitle',
  TITLE: 'title'
};
var CONFIG = {
  tag: {
    label: Label,
    subtitle: View,
    title: H4
  },
  darkTheme: {
    label: color.secondaryTextThemeDark,
    subtitle: color.secondaryTextThemeDark,
    title: color.primaryTextThemeDark
  }
};
var styles = {
  cardLabel: {
    color: color.secondaryText
  },
  cardSubtitle: {
    color: color.secondaryText
  },
  cardTitle: {
    color: color.primaryText
  }
};
var textStyles = {
  label: styles.cardLabel,
  subtitle: styles.cardSubtitle,
  title: styles.cardTitle
};

function getDarkThemeStyle(type) {
  return {
    color: CONFIG.darkTheme[type]
  };
}

function CardText(_ref) {
  var htmlAttributes = _ref.htmlAttributes,
      isThemeDark = _ref.isThemeDark,
      maxLines = _ref.maxLines,
      rootClassName = _ref.rootClassName,
      shouldTruncate = _ref.shouldTruncate,
      style = _ref.style,
      text = _ref.text,
      type = _ref.type,
      shouldRenderDiv = _ref.shouldRenderDiv;
  var Tag = CONFIG.tag[type];
  var darkThemeStyle = isThemeDark ? getDarkThemeStyle(type) : {};

  var mergedStyles = _objectSpread({}, textStyles[type], darkThemeStyle, style);

  var shouldTruncateText = shouldTruncate && typeof text === 'string';
  var elementTag = shouldRenderDiv && 'div';
  return React.createElement(Tag, _extends({
    rootClassName: rootClassName,
    style: mergedStyles,
    tag: elementTag
  }, htmlAttributes), shouldTruncateText && React.createElement(TextTruncate, {
    line: maxLines,
    text: text
  }), !shouldTruncateText && text);
}

CardText.defaultProps = {
  type: CARD_TEXT_TYPE.LABEL,
  maxLines: 3
};
export default compose(setDisplayName('CardTextHOC'), getContext({
  isThemeDark: PropTypes.bool
}))(CardText);